import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

const URL_ADMIN_INCENTIVE_BUDGETS = `${URL_APP_ADMIN}/incentive-budgets`
const URL_ADMIN_INCENTIVE_BUDGETS_LIST = `${URL_ADMIN_INCENTIVE_BUDGETS}/list`
const URL_ADMIN_INCENTIVE_BUDGETS_EVENTS = `${URL_ADMIN_INCENTIVE_BUDGETS}/events`
// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'app-admin-incentive-budgets'>
  | DashRouteType<'app-admin-incentive-budgets-list'>
  | DashRouteType<'app-admin-incentive-budgets-events'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-incentive-budgets': URL_ADMIN_INCENTIVE_BUDGETS,
  'app-admin-incentive-budgets-list': URL_ADMIN_INCENTIVE_BUDGETS_LIST,
  'app-admin-incentive-budgets-events': URL_ADMIN_INCENTIVE_BUDGETS_EVENTS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
